

function Footer() {
  return (
    <footer className="bg-gray-800 text-white text-center p-4 flex flex-col relative bottom-0 w-full">
        <p>© 2025 Mui Dao</p>
        <p>Address: 39 Hai Thuong Lan Ong, 10 Ward, 5 District, Ho Chi Minh City</p>
        <p>Phone: 0773.153.xxx</p>

    </footer>
  );
}

export default Footer;